import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
const IconMaterialsDesigned = props => {
  const $ = _c(7);
  const color = props.color || "#585858";
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M32.581 40.335l-11.29 6.321a2.675 2.675 0 01-2.644-.011l-11.155-6.37a2.803 2.803 0 01-1.398-2.417L6 25.245a2.806 2.806 0 011.405-2.462l11.319-6.431a2.68 2.68 0 012.612-.024l11.219 6.116A2.798 2.798 0 0134 24.906v12.982a2.801 2.801 0 01-1.419 2.447zM20 32v15" />;
    t1 = <path d="M6 24l12.71 6.678c.806.425 1.777.43 2.588.014L34 24.172M20 11V0M9 16L1 8M39 7l-8 8" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== color) {
    t2 = <g stroke={color} strokeWidth={2} fill="none" fillRule="evenodd">{t0}{t1}</g>;
    $[2] = color;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== props || $[5] !== t2) {
    t3 = <svg width={40} height={48} viewBox="0 0 40 48" {...props}>{t2}</svg>;
    $[4] = props;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
IconMaterialsDesigned.propTypes = {
  color: PropTypes.string
};
export default IconMaterialsDesigned;